import { Keys } from '../types';

const keys: Keys = {
  infura: 'd0358b4197454c98ade7e1222e6df34a',
  alchemy: 'cQGZUiTLRCFsQS7kbRxPJK4eH4fTTu88',
  graph: '7c7b4c36244b0b86171a3931eaf9bb23',
  balancerApi: 'da2-7a3ukmnw7bexndpx5x522uafui',
};

export default keys;
